import { Collapse, Divider, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/material';
import { Styles } from '@t2c/shared-fe';
import { useState } from 'react';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import { useAuth } from '../../hooks';
import Markdown from 'react-markdown';

const costBreakDownMarkdownContent = `
- **ChatBot** : Unlimited Credits

- **AI Video Models**:  
  &nbsp;&nbsp;&nbsp;&nbsp; - Seedance 2.5 = 283,800 credits / second    
  &nbsp;&nbsp;&nbsp;&nbsp; - Seedance 2.0 = 182,040 credits / second    
  &nbsp;&nbsp;&nbsp;&nbsp; - Seedance 2.0 Fast = 145,620 credits / second    
  &nbsp;&nbsp;&nbsp;&nbsp; - Kling 2.6 Pro = 44,000 credits / second    
  &nbsp;&nbsp;&nbsp;&nbsp; - Kling 3 Pro =  235,200 credits / second    
  &nbsp;&nbsp;&nbsp;&nbsp; - Kling 3 Pro Motion Control = 100,800 credits / second    
  &nbsp;&nbsp;&nbsp;&nbsp; - Kling 2.5 Turbo = 45,000 credits / second    
  &nbsp;&nbsp;&nbsp;&nbsp; - Seedance 1.0 Pro = 77,500 credits / second    
  &nbsp;&nbsp;&nbsp;&nbsp; - Google Veo 3 = 472,500 credits / second    
  &nbsp;&nbsp;&nbsp;&nbsp; - Google Veo 3 Fast = 252,000 credits / second   
  &nbsp;&nbsp;&nbsp;&nbsp; - Google Veo 3.1 = 472,500 credits / second   
  &nbsp;&nbsp;&nbsp;&nbsp; - Google Veo 3.1 Fast = 252,000 credits / second    
  &nbsp;&nbsp;&nbsp;&nbsp; - Runway Character Mimic = 30,000 credits / second    
  &nbsp;&nbsp;&nbsp;&nbsp; - Wan 2.1 Plus = 315,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Wan 2.1 Turbo = 113,500 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Wan 2.2 Plus = 315,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Wan 2.5 Preview = 315,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Minimax Video 01 = 270,000 credits / generation  
  &nbsp;&nbsp;&nbsp;&nbsp; - Minimax Video 01 live2d = 270,000 credits / generation  
  &nbsp;&nbsp;&nbsp;&nbsp; - Minimax Hailuo 02 = 51,450 credits / second    
  &nbsp;&nbsp;&nbsp;&nbsp; - Pixverse v5 = 252,000 credits / generation    

- **Image Models**      
  &nbsp;&nbsp;&nbsp;&nbsp; - Nano Banana Pro = 180,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Nano Banana 2 = 96,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - GPT Image 2 = 126,600 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Stability AI Large = 97,500 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Stability AI Turbo = 30,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Stability AI Medium = 52,500 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Runway Gen 4 Turbo = 12,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Recraft V3 = 2,520,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - USO = 65,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Nano Banana: 23,400 / generation  
  &nbsp;&nbsp;&nbsp;&nbsp; - Seedream 4.5 = 24,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Seedream 4.0 = 19,500 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Seedream 3.0 = 18,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Flux pro v1.1 ultra = 3,780,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Flux pro v 1.1 = 2,520,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Flux realism = 2,205,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Flux Dev = 1,575,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Flux schnell = 189,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Flux Kontext Max = 51,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Flux Kontext Pro = 25,200 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Flux Srpo = 15,000 credits / generation    
  &nbsp;&nbsp;&nbsp;&nbsp; - Qwen = 30,000 credits / generation    

- **Voiceover Models**  
  &nbsp;&nbsp;&nbsp;&nbsp; - ElevenLabs = 160,000 credits / minute = 37.5 minutes/mo ~ avg audio = 2 minutes = 18+ audio exports/mo or 225 audio exports/yr   
  &nbsp;&nbsp;&nbsp;&nbsp; - Fish Audio = 9,000 credits / minute  = 666 minutes/mo ~ avg audio = 2 minutes = 333+ audio exports/mo or 4000 audio exports/yr

- **Lip Sync Models**  
  &nbsp;&nbsp;&nbsp;&nbsp; - HeyGen = 280,000 credits / minute = 21.5 minutes/mo ~ avg video = 2 minutes = 10+ video exports/mo or 128 video exports/yr  
  &nbsp;&nbsp;&nbsp;&nbsp; - Hedra = 1,728,000 credits / minute = 3.5 minutes/mo ~ avg video = 2 minutes = 2+ video exports/mo or 24 video exports/yr

- **AI Music**: 80,000 credits / minute = 75 minutes/mo ~ avg music = 20 seconds = 375+ music exports/mo or 4500+ music exports/yr
- **Captions & Effects**: 50,000 credits / minute = 120 minutes/mo ~ avg video = 60 seconds = 120 video exports/mo or 1440 video exports/yr
- **Timeline Editor**: 50,000 credits / minute = 120 minutes/mo ~ avg video = 60 seconds = 120 video exports/mo or 1440 video exports/yr
- **Upscale Videos**: 80,000 credits / second = 75 seconds/mo ~ avg video = 5 seconds = 15 video exports/mo or 180 video exports/yr

- **Custom/Private Audio(s) for Voiceover**  
  &nbsp;&nbsp;&nbsp;&nbsp; - ElevenLabs = 3 Custom Audio(s)   
  &nbsp;&nbsp;&nbsp;&nbsp; - Fish Audio = Unlimited Custom Audios  


---

#### **Note:** NEW Chat, Image, Audio, and Video Models Are Constantly Added

`;

const FAQ = [
  {
    id: 1,
    que: 'What is TXT2Create?',
    ans: 'We are an AI wholesaler. We partner with top AI providers like OpenAI, Google, Runway, Hedra and others to integrate their official paid versions into one seamless platform. You get access to all premium features without managing multiple subscriptions. This saves you a ton of money and provides you the exact same models you would get from them individually.',
  },
  {
    id: 2,
    que: 'How can you offer premium AI models at such a low price?',
    ans: 'We buy smarter. Instead of paying retail, we negotiate wholesale-style deals directly with AI providers and pass those savings straight to you. You still get the full, premium versions of models that normally cost $20-$100/month — just without the inflated price tag.',
  },
  {
    id: 3,
    que: 'Which AI tools and models are available?',
    ans: "Pretty much the entire universe. You'll find GPT-5, Veo 3, 3.1, etc, Seedance 2.5, Flux, Stable Diffusion, Midjourney, Ideogram, DeepSeek, Gamma, Kling 2.6 and previous versions, Hailuo, Runway, HeyGen, ElevenLabs, Fish, GPT Image 2, Nano Banana Pro, Pixverse, Wan, Pika, Vidu, Hedra, Veed, Recraft, Hunyuan, ByteDance, Meshy AI, LTX, Topaz, and pretty much every other model you would ever want.\n\nIf it's important, it’s here. And we add new models the same week they drop.",
  },
  {
    id: 4,
    que: 'What is Everything Agent?',
    ans: 'Everything Agent is the autonomous version of TXT2Create. Instead of running one generation at a time, it can plan and execute multi-model workflows in the background.',
  },
  {
    id: 5,
    que: 'What can Everything Agent do?',
    ans: 'It can run image, video, voice, and lip-sync workflows in parallel, create 20 social videos or 50 UGC clips in one click, and help you ship full campaigns hands-free.',
  },
  {
    id: 6,
    que: 'What does a “credit” mean on txt2create?',
    ans: 'Credits are simply how you access AI tools on the platform. Different tools use different amounts depending on how heavy the task is—quick text prompts use far less than image or video generation.\n\nAnd honestly? Most people never come close to using all their credits. We keep it simple and fair instead of nickel-and-diming you.',
  },
  {
    id: 7,
    que: 'How many credits will I receive?',
    ans: 'Agent Annual Plan: Receive 216M credits upfront.\n\nAgent Monthly Plan: Receive 18M credits per month.\n\n\nAll-Access Annual Plan: Receive 72M credits upfront.\n\nAll-Access Monthly Plan: Receive 6M credits per month.\n\n\nNote: Our plans are designed for high-volume usage; 95% of our users find these limits more than sufficient. Should you require more, additional credits can be purchased at any time for just $5.',
    // ans: 'All-Access Annual Plan: Receive 72M credits upfront.\n\nAll-Access Monthly Plan: Receive 6M credits per month.\n\n\nNote: Our plans are designed for high-volume usage; 95% of our users find these limits more than sufficient. Should you require more, additional credits can be purchased at any time for just $5.',
  },
  {
    id: 8,
    que: 'On the annual plan, do we receive all our credits at once or monthly?',
    ans: 'All the credits will be received immediately at purchase',
  },
  {
    id: 9,
    que: 'Do credits roll over to the next month?',
    ans: 'For monthly plans, credits are cumulative and roll over to the following month. For yearly plans, you receive all credits at once upfront.',
  },
  {
    id: 10,
    que: 'How are credits calculated for different features?',
    ans: costBreakDownMarkdownContent,
  },
  {
    id: 11, // Has special handling
    que: 'Is plan cancellation supported?',
    ans: (isAuthenticated: boolean, isPublic?: boolean) => {
      if (isAuthenticated && !isPublic) {
        return 'Yes, plan cancellation is supported. You can cancel your plan anytime from the [profile](/profile) page.';
      } else {
        return 'Yes, plan cancellation is supported. You can cancel your plan anytime from the profile page.';
      }
    },
  },
  {
    id: 12,
    que: 'Do you offer any enterprise subscription plans?',
    ans: 'No',
  },
  {
    id: 13,
    que: 'How do I connect txt2create with other AI agents?',
    ans: 'Using the built-in MCP server. Works with Claude, Codex, Cursor, Antigravity, OpenClaw, and other MCP-compatible AI agents.',
  },
];

export const PlansFAQ = ({ isPublic }: { isPublic?: boolean }) => {
  const [openQue, setOpenQue] = useState(null);
  const {
    auth: { isAuthenticated },
  } = useAuth();

  const handleOnclickQue = (id: number) => {
    if (openQue !== id) setOpenQue(id);
    else setOpenQue(null);
  };

  const theme = useTheme();

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.heading}>Frequently Asked Questions</Typography>
      <Box sx={styles.faqWrapper} mt={4}>
        {FAQ.map((res, index) => (
          <Box key={index} sx={styles.faqItemContainer}>
            <Box onClick={() => handleOnclickQue(res.id)} sx={{ ...styles.row, cursor: 'pointer' }}>
              <Typography sx={styles.faqQuestion}>{res.que}</Typography>
              {openQue === res.id ? (
                <RemoveRoundedIcon sx={styles.faqChevronOpen} />
              ) : (
                <AddRoundedIcon sx={styles.faqChevron} />
              )}
            </Box>
            <Collapse in={openQue === res.id}>
              <Box sx={styles.faqAnswerWrap}>
                <Typography sx={styles.faqAnswer}>
                  <Markdown
                    components={{
                      a: ({ href, children }) => (
                        <Box component="a" href={href} sx={styles.link}>
                          {children}
                        </Box>
                      ),
                    }}
                  >
                    {typeof res.ans === 'function' ? res.ans(isAuthenticated, isPublic) : res.ans}
                  </Markdown>
                </Typography>
              </Box>
            </Collapse>
            {index !== FAQ.length - 1 && <Divider sx={styles.faqDivider} />}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const styles: Styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    mt: 2,
    mb: 4,
    alignSelf: 'center',
    alignItems: 'center',
  },
  faqWrapper: {
    maxWidth: '100%',
  },
  heading: {
    fontSize: 'clamp(24px, 5vw, 40px)',
    fontWeight: 600,
    alignSelf: 'center',
    textAlign: 'center',
    mb: 2,
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: { xs: 1.25, sm: 1.5 },
    py: { xs: 1.25, sm: 1.5 },
    borderRadius: 0,
    backgroundColor: 'transparent',
    transition: 'transform 180ms ease',
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-1px)',
    },
  },
  faqItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
    py: 0.5,
  },
  faqQuestion: {
    fontSize: 'clamp(18px, 4vw, 24px)',
    fontWeight: 600,
    color: (theme) => theme.palette.common.white,
    mb: 0,
  },
  faqAnswer: {
    color: (theme) => theme.palette.text.lighterText2,
    fontSize: 'clamp(14px, 3vw, 18px)',
    lineHeight: 1.45,
  },
  faqAnswerWrap: {
    px: { xs: 1.25, sm: 1.5 },
    pb: { xs: 1.25, sm: 1.5 },
  },
  faqDivider: {
    backgroundColor: (theme) => theme.palette.text.lighterText,
    height: 1,
    my: 0.5,
  },
  faqChevron: {
    color: (theme) => theme.palette.text.secondary,
    transition: 'transform 220ms ease',
    fontSize: 20,
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: (theme) => `1px solid ${theme.palette.text.lighterText}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
  },
  faqChevronOpen: {
    color: '#7B35EF',
    transition: 'transform 220ms ease',
    fontSize: 20,
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: (theme) => `1px solid ${theme.palette.text.lighterText}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
  },
  link: {
    color: (theme) => theme.palette.background.activeBorder,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
};
